import { Grid, IconButton, List, ListItem, Stack, Typography } from '@mui/material';
import { React } from 'react';
import globals from '../globals';
import FacebookIcon from '@mui/icons-material/Facebook';
import InstagramIcon from '@mui/icons-material/Instagram';
import YouTubeIcon from '@mui/icons-material/YouTube';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import '../globals';
import styled from '@emotion/styled';

const Footer = () => {

    const IconStyled = styled(IconButton)(() => ({
        color: globals.colors.textColor,
    }))


    return (
        <Grid container direction={'row'} justifyContent={'space-evenly'} alignItems={'start'} mt={5} mb={5}>
            <Grid item alignItems={'center'} mt={10}>
                <a href='/'><img src={'/eacademiabg-logo.webp'} height={90} /></a>
            </Grid>
            <Grid item>
                <Stack direction={'column'} spacing={2}>
                    <Typography variant="h6" sx={{ display: 'flex', color: globals.colors.lightRed, fontWeight: 'bold', py: 2 }}>Контакти</Typography>
                    <ul style={{ listStyleType: "none", padding: 0, margin: 0, display: 'flex', flexDirection: 'column', gap: 10 }}>
                        <li><strong>Имейл:</strong></li>
                        <li><a href='mailto:info@eacademiabg.com' style={{ textDecoration: "none", color: "black" }}>info@eacademiabg.com</a></li>
                        <li><strong>Телефон:</strong></li>
                        <li><a href='tel:+359878852548' style={{ textDecoration: "none", color: "black" }}>0878852548</a></li>
                    </ul>
                    <Grid container direction={'row'} justifyContent={'space-evenly'}>
                        <IconStyled href='https://www.facebook.com/eacademiabg' color='info'>
                            <FacebookIcon fontSize='large' />
                        </IconStyled>
                        <IconStyled href='https://www.instagram.com/eacademiabg/' color='primary'>
                            <InstagramIcon fontSize='large' />
                        </IconStyled>
                        <IconStyled href='https://www.youtube.com/@eacademiabg8334' color='primary'>
                            <YouTubeIcon fontSize='large' />
                        </IconStyled>
                        <IconStyled href='https://www.linkedin.com/company/eacademiabg/' color='primary'>
                            <LinkedInIcon fontSize='large' />
                        </IconStyled>
                    </Grid>
                </Stack>
            </Grid>
            <Grid item>
                <Stack direction={'column'} spacing={2}>
                    <Typography variant="h6" sx={{ display: 'flex', color: globals.colors.lightRed, fontWeight: 'bold', py: 2 }}>Навигация</Typography>
                    <ul style={{ listStyleType: "none", padding: 0, margin: 0, display: 'flex', flexDirection: 'column', gap: 10 }}>
                        <li><a href='/' style={{ textDecoration: "none", color: "black" }}>Начало</a></li>
                        <li><a href='/courses' style={{ textDecoration: "none", color: "black" }}>Курсове</a></li>
                        <li><a href='/instructors' style={{ textDecoration: "none", color: "black" }}>Учители</a></li>
                        {/* <li><a href='/about-us' style={{ textDecoration: "none", color: "black" }}>Конкурси</a></li> */}
                        <li><a href='/about-us' style={{ textDecoration: "none", color: "black" }}>За нас</a></li>
                        <li><a href='/login' style={{ textDecoration: "none", color: "black" }}>Вход</a></li>
                        <li><a href='/register' style={{ textDecoration: "none", color: "black" }}>Регистрация</a></li>
                    </ul>
                </Stack>
            </Grid>
            <Grid item>
                <Stack direction={'column'} spacing={2}>
                    <Typography variant="h6" sx={{ display: 'flex', color: globals.colors.lightRed, fontWeight: 'bold', py: 2 }}>Политики</Typography>
                    <ul style={{ listStyleType: "none", padding: 0, margin: 0, display: 'flex', flexDirection: 'column', gap: 10 }}>
                        <li><a href='/terms-and-conditions' style={{ textDecoration: "none", color: "black" }}>Общи условия</a></li>
                        <li><a href='/cookies' style={{ textDecoration: "none", color: "black" }}>Политики за бисквитките</a></li>
                        <li><a href='/privacy-policy' style={{ textDecoration: "none", color: "black" }}>Политики за поверителност</a></li>
                    </ul>
                </Stack>
            </Grid>
        </Grid>
    );
}
export default Footer;
